import * as React from 'react';
import * as style from './style.css';
import { HEADER_ITEMS } from '../../../OffersTable';
import { UIText2 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const SkeletonTableHead = () => {
  return /*#__PURE__*/_jsx("div", {
    className: style['table-header'],
    children: HEADER_ITEMS.map((item, index) => /*#__PURE__*/_jsx("div", {
      className: style['header-cell'],
      children: /*#__PURE__*/_jsx(UIText2, {
        color: "current_color",
        textAlign: index === 3 ? 'right' : 'left',
        children: item
      })
    }, index))
  });
};